module.exports = __webpack_public_path__ + "66cb79e03e0e0c69e7cc6ab9a0d20b1e.jpg";